<div class="spinner-container"
     [style.width.px]="sizePx"
     [style.height.px]="sizePx">

  <!-- SVG spinner -->
  <!-- Adapted from: https://www.benmvp.com/blog/how-to-create-circle-svg-gradient-loading-spinner/ -->
  <svg [attr.width]="sizePx"
       [attr.height]="sizePx"
       [attr.viewBox]="viewBox">

    <defs>
      <linearGradient id="spinner-secondHalf">
        <stop offset="0%" stop-opacity="0" stop-color="currentColor"/>
        <stop offset="25%" stop-opacity="0" stop-color="currentColor"/>
        <stop offset="100%" stop-opacity="0.5" stop-color="currentColor"/>
      </linearGradient>
      <linearGradient id="spinner-firstHalf">
        <stop offset="0%" stop-opacity="1" stop-color="currentColor"/>
        <stop offset="100%" stop-opacity="0.5" stop-color="currentColor"/>
      </linearGradient>
    </defs>

    <g [attr.stroke-width]="strokePx"
       fill="transparent">
      <path stroke="url(#spinner-secondHalf)"
            [attr.d]="secondHalfPath"/>
      <path stroke="url(#spinner-firstHalf)"
            [attr.d]="firstHalfPath"/>
      <path stroke="currentColor"
            stroke-linecap="round"
            [attr.d]="roundCapPath"/>
    </g>

    <animateTransform from="0 0 0"
                      to="360 0 0"
                      attributeName="transform"
                      type="rotate"
                      repeatCount="indefinite"
                      [attr.dur]="loopIntervalMs + 'ms'"/>
  </svg>
</div>

@if (faIcon) {
  <fa-icon
    [icon]="faIcon"
    [size]="faIconSize">
  </fa-icon>
}
